import React from 'react'

export const southCarolinaSetupVars = {
  siteId: 'south_carolina',
  pathPrefix: '/sc',
  menuHeader: "Discover South Carolina's Solution for:",
  appUrl: 'https://sc.headed2.com',
  logoImg: '/images/assets/south_carolina/horizontal/dark.svg',
  headerTitle: `The South Carolina CareerExplorer is a system designed for South Carolina`
}
